import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ParentTemplateFolder from "@/services/template/parent-template-folder";

export function useDeleteParentTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await ParentTemplateFolder.deleteParentTemplateFolder(id);
      if (!response.data.status) {
        throw new Error(response.data.msg || "Failed to delete parent template folder");
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["parentTemplateFolders"] });
    },
  });
}
